import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {RouterModule} from '@angular/router';
import {DesignModule} from '../../design/design.module';
import {OphAvatarComponent} from '../../design/oph-avatar/oph-avatar.component';
import {SharedProjectsModule} from '../../projects/shared-projects.module';
import {NavbarUserComponent} from './navbar-user/navbar-user.component';
import {PageTitleComponent} from './page-title/page-title.component';

@NgModule({
  imports: [
    CommonModule,
    DesignModule,
    RouterModule,
    MatListModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    SharedProjectsModule,
    MatButtonToggleModule,
    ReactiveFormsModule,
    OphAvatarComponent,
    NavbarUserComponent,
  ],
  declarations: [PageTitleComponent],
  exports: [DesignModule, RouterModule, PageTitleComponent],
})
export class SharedLayoutModule {}
